// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__35rKK","option":"styles_option__3SF72","selected":"styles_selected__I2_mO"};